export default __webpack_public_path__ + "static/media/logo-KCNI_color.0e8656dc.png";